import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import './index.css'

const MemberDetailRow = ({ member, isCompanyPolicy }) => {
  const getAge = (date) => {
    const birthDate = new Date(date)
    const birthYear = birthDate?.getFullYear()
    const presentDate = new Date()
    const presentYear = presentDate?.getFullYear()
    return presentYear - birthYear
  }

  const showEmpId = () => {
    return isCompanyPolicy
  }

  const classes = useStyles()
  return (
    <>
      <Accordion>
        <div className='member-details-row-text-container'>
          {showEmpId() ? (
            <span className='member-details-row-text'>{member?.empId}</span>
          ) : null}
          <span className='member-details-row-text'>{member?.firstName}</span>
          <span className='member-details-row-text'>
            {getAge(member?.dateOfBirth)}
          </span>

          <span className={classes.ceoRelationText}>
            {member?.dependents?.length > 0 ? (
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                id='relationAccordion'
              >
                {member?.relation} + {member?.dependents?.length}
              </AccordionSummary>
            ) : (
              <AccordionSummary className={classes.selfZeroRow}>
                {member?.relation}
              </AccordionSummary>
            )}
          </span>
        </div>
        <AccordionDetails className={classes.accordionDetails}>
          {member?.dependents?.length &&
            member?.dependents?.map((temp) => (
              <div className='flex' key={`dependent__${temp?.id}`}>
                {showEmpId() ? (
                  <span className='member-details-row-text'></span>
                ) : null}
                <span className='member-details-row-text'>
                  {temp?.firstName}
                </span>
                <span className='member-details-row-text'>
                  {getAge(temp?.dateOfBirth)}
                </span>
                <span className='member-details-row-text'>
                  {temp?.relation}
                </span>
              </div>
            ))}
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default MemberDetailRow

const useStyles = makeStyles({
  text: {
    fontWeight: '500',
    color: COLORS.GREY,
    width: '100%',
    fontSize: '12px',
    paddingLeft: '10px',
    textAlign: 'left',
    marginTop: '15px',
  },
  textContainer: {
    display: 'flex',
    paddingLeft: '10px',
  },
  selfZeroRow: {
    pointerEvents: 'none',
  },
  ceoRelationText: {
    fontWeight: '500',
    color: COLORS.GREY,
    width: '15vw',
    fontSize: '12px',
    marginTop: '-7px',
    paddingLeft: '10px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  accordionDetails: {
    paddingTop: 0,
  },
  viewAllContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '5px',
  },
  viewAllText: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: COLORS.DARK_PINK,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  modalRoot: {
    width: '60%',
    maxHeight: '90%',
    padding: '20px',
    overflowY: 'auto',
    background: '#fff',
  },
})
